import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import MultiSelect from '@khanacademy/react-multi-select'

import ComponentSearch from '../../../../Shared/ComponentSearch'
import Icon from '../../../../Shared/Icon/Icon'

class JobListFilters extends React.Component {
  constructor() {
    super()

    this.state = {
      isExpanded: false,
    }

    this.handleExpand = this.handleExpand.bind(this)
  }

  handleExpand() {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  render() {
    const className = this.state.isExpanded ? 'form-inline--is-expanded' : ''

    return (
      <div className="products-list__filters">
        <div className={`form-inline row justify-content-between ${className}`}>
          <div className="form-inline__column-toggler col-sm-12">
            <div className="form-inline__mobile-toggle" onClick={() => this.handleExpand()}>
              <span>Search & filter</span>
              <Icon type={['far', 'chevron-down']} className="form-inline__mobile-toggle-icon" />
            </div>
          </div>
          <div className="col-sm-12 col-md-4">
            <ComponentSearch
              onSearchSubmit={this.props.onSearchSubmit}
              searchPlaceholder="Search"
              searchTerm={this.props.filters.term}
              onTermChange={this.props.onTermChange}
              isDisabled={this.props.isDisabled}
            />
          </div>
          <div className="col-sm-12 col-md-8">
            <div className="row justify-content-end">
              <div className="col-sm-12 col-md-4 col-lg-3">
                <MultiSelect
                  options={this.props.filterTypeOptions}
                  onSelectedChanged={(value) => this.props.onFiltersChange({
                    ...this.props.filters,
                    type: value,
                  })}
                  selected={this.props.filters.type}
                  placeholder="Type"
                  disabled={this.props.isDisabled}
                  hasSelectAll={false}
                  disableSearch
                />
              </div>
              {this.props.filters.tab === 'archive' && (
                <div className="col-sm-12 col-md-4 col-lg-3">
                  <MultiSelect
                    options={this.props.filterStatusOptions}
                    onSelectedChanged={(value) => this.props.onFiltersChange({
                      ...this.props.filters,
                      status: value,
                    })}
                    selected={this.props.filters.status}
                    placeholder="Status"
                    disabled={this.props.isDisabled}
                    hasSelectAll={false}
                    disableSearch
                  />
                </div>
              )}
              {this.props.filters.tab !== 'archive' && (
                <div className="col-sm-12 col-md-4">
                  <Select
                    name="jobs-list-sort"
                    value={this.props.filters.sortBy}
                    options={this.props.sortOptions}
                    onChange={this.props.onSortChange}
                    placeholder="Sort"
                    className="Select-outline"
                    searchable={false}
                    clearable={false}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

JobListFilters.propTypes = {
  onSearchSubmit: PropTypes.func.isRequired,
  onTermChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  filterTypeOptions: PropTypes.array.isRequired,
  filterStatusOptions: PropTypes.array.isRequired,
  onFiltersChange: PropTypes.func.isRequired,
  sortOptions: PropTypes.array.isRequired,
  onSortChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    term: PropTypes.string.isRequired,
    sortBy: PropTypes.string.isRequired,
    type: PropTypes.array.isRequired,
    status: PropTypes.array.isRequired,
    tab: PropTypes.string.isRequired,
  }).isRequired,
}

JobListFilters.defaultProps = {
  isDisabled: false,
}

export default JobListFilters
